import dayjs from "dayjs";

const Comment = (props) => {
    return <><div>{props.comment.comment}</div>
        <div style={{ fontSize: "0.8em" }}>{dayjs(props.comment.CreatedAt).format("DD.MM.YYYY hh:mm:ss")} - {props.comment.name}</div><hr /></>
}

export default Comment
